import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const addCenter = (center, oldRecents) => {
  if (oldRecents.some(({ uuid }) => uuid === center.uuid))
    return { recents: oldRecents };

  return { recents: [center, ...oldRecents].slice(0, 5) };
};

const useBowlingCentersStore = create(
  persist(
    (set) => ({
      current: null,
      recents: [],
      addCurrentCenter: (center) => {
        set({ current: center });
      },
      addRecentCenter: (center) => {
        set(({ recents }) => addCenter(center, recents));
      },
      updateRecents: (newRecents) => {
        set({ recents: newRecents.slice(0, 5) });
      },
    }),
    { name: 'lt-bowling-centers' }
  )
);

export default useBowlingCentersStore;
